export default __webpack_public_path__ + "static/ingredientlibrary-2aa62f0c1306db009968302e5129831c.png";